module.exports = __webpack_public_path__ + "static/logo-bea4ab5ce8aed5481052e0db5e160745.png";